/**
 * JS mirror of src/theme/tokens.css for charts, toast, and inline usage
 * where CSS variables are awkward. Keep in sync with --color-* tokens.
 */
export const brandColors = {
  ink: "#000000",
  inkMuted: "rgba(0, 0, 0, 0.65)",
  canvas: "#f4f4f4",
  surface: "#ffffff",
  elevated: "#fafafa",
  border: "rgba(0, 0, 0, 0.12)",
  primary: "#000000",
  primaryHover: "#1a1a1a",
  onPrimary: "#ffffff",
  danger: "#d32f2f",
  warning: "#ff9d00",
  chartOrange: "#ff9d00",
  chartGreen: "#64be37",
};
